import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterEntranceComponent } from './component/register-entrance.component';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/appclient';

@NgModule({
  declarations: [RegisterEntranceComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class RegisterEntranceModule { }
